import type { TokenType } from "@/features/bridge/types/token-selector.types";
import { create } from "zustand";

interface TokenWindowControlsStoreType {
  isCardsLoaded: boolean;
  setIsCardsLoaded: (val: boolean) => void;
  activeTokenWindowType: TokenType | null;
  setActiveTokenWindowType: (currentlyActive: TokenType | null) => void;
}

export const useTokenWindowControls = create<TokenWindowControlsStoreType>(
  (set) => ({
    // Whether the cards have finished loading or not
    isCardsLoaded: false,
    setIsCardsLoaded: (val) => set({ isCardsLoaded: val }),

    // State for NFT window activity
    activeTokenWindowType: null,
    setActiveTokenWindowType: (currentlyActive) =>
      set({ activeTokenWindowType: currentlyActive }),
  }),
);
